<script>
    import AudioPage from "./AudioPage.svelte";
    import { push } from "svelte-spa-router";
    import { getEntity, getEntities } from "../../../../api-client";
    import { _ } from "svelte-i18n";
    import AudioGuideGuard from "../../guards/AudioGuideGuard.svelte";
    import LoadingSquare from "../../../../common/LoadingSquare.svelte";

    export let params = {};

    $: audioGuideId = params.id;
    $: trackId = params.trackId;

    $: promise = Promise.all([
        getEntity("audio_guide", audioGuideId),
        getEntities("guide_track"),
        getEntities("audio_info"),
    ]).then(([guide, tracks, infos]) => {
        if (guide && tracks) {
            guide.tracks = tracks.filter((track) =>
                guide.fk_tracks.includes(track.id)
            );
            guide.tracks.sort((a, b) => a.trackId - b.trackId);

            let track = guide.tracks.find((track) => track.id === trackId);
            track.info = infos.find((info) => info.id === track.fk_audio_info);

            return [guide, track];
        }
    });
</script>

{#await promise}
    <LoadingSquare />
{:then [audioGuide, track]}
    <AudioGuideGuard {audioGuide} />
    <AudioPage
        showNext={audioGuide.tracks.indexOf(track) <
            audioGuide.tracks.length - 1}
        showBack={audioGuide.tracks.indexOf(track) > 0}
        image={track.image}
        track={track.src}
        on:switchForward={() =>
            push(
                `/audio-guide/${audioGuideId}/${
                    audioGuide.tracks[audioGuide.tracks.indexOf(track) + 1].id
                }`
            )}
        on:switchBackwards={() =>
            push(
                `/audio-guide/${audioGuideId}/${
                    audioGuide.tracks[audioGuide.tracks.indexOf(track) - 1].id
                }`
            )}
        audioTitle={track.title}
        audioInfo={track.info}
        headerTitle={$_("audio_guide")}
        audio={track.src}
    />
{:catch}
    <div class="error">
        <span class="text-l" style="font-size: 24px;">
            {$_("entity_load_error")}
        </span>
    </div>
{/await}
